import { Fragment } from "react";
import { useParams, useNavigate } from "react-router-dom";

import PageHeader from "../component/layout/pageheader";
import Header from "../component/layout/header";
import Footer from "../component/layout/footer";


import teamPlayers from "../component/data/teamPlayers";

const TeamSinglePage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const player = teamPlayers.find(p => p.slug === slug);

  if (!player) {
    return (
      <div className="text-center padding-top padding-bottom">
        <h2>Member not found</h2>
        <button className="default-button mt-3" onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>
    );
  }

  

  return (
    <Fragment>
      <Header />

  
      <div className="team-player-page padding-top">
       

        {/* ================= PLAYER HERO ================= */}
        <section className="player-hero padding-top padding-bottom">
          <div className="container">
            <div className="row align-items-center">

              {/* IMAGE */}
              <div className="col-lg-5">
                <div className="player-image">
                  <img src={player.image} alt={player.name} />
                </div>
              </div>

              {/* INFO */}
              <div className="col-lg-7">
                <span className="player-status">{player.status}</span>
                
                <h1 className="player-name">
                <span className="text-anim-typing js-animate">
                    {player.name}
                </span>
                </h1>

                <p className="player-role">{player.role}</p>

                <ul className="player-meta">
                  <li><strong>Team Role:</strong> {player.teamRole}</li>
                  <li><strong>Nationality:</strong> {player.nationality}</li>
                </ul>

                <p className="player-description text-anim-fade-down js-animate delay-sm">
                  {player.description}
                </p>

                <button
                  className="default-button "
                  onClick={() => navigate("/")}
                >
                  <span>Back to Home</span>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* ================= STATS ================= */}
        {player.wins !== null && (
          <section className="player-stats-section padding-bottom">
            <div className="container">
              <div className="row text-center fade-up">
                <div className="col-md-4">
                  <div className="stat-card">
                    <h2>{player.wins}</h2>
                    <p>Wins</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="stat-card ">
                    <h2>{player.losses}</h2>
                    <p>Losses</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="stat-card">
                    <h2>{player.draws}</h2>
                    <p>Draws</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* ================= HIGHLIGHTS ================= */}
        <section className="player-highlights padding-top padding-bottom">
          <div className="container">
            <h2 className="text-center mb-4">Key Highlights</h2>
            <ul className="highlight-list">
              {player.highlights.map((item, i) => (
                <li key={i}>
                  <i className="icofont-check-circled"></i> {item}
                </li>
              ))}
            </ul>
          </div>
        </section>

   
      </div>

   
      <Footer />
    </Fragment>
  );
};

export default TeamSinglePage;
